export const SUCCESSFUL_EVALUATION_ACCURACY_THRESHOLD = 67;

export function isSuccessfulEvaluationAccuracy(accuracy?: number) {
  if (accuracy >= SUCCESSFUL_EVALUATION_ACCURACY_THRESHOLD) return true;

  return false;
}
